// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/auth/signin/:rest*?\",\"regex\":\"^/auth/signin(?:/(.*))?$\",\"paramNames\":[\"rest\"],\"hasOptionalPrefix\":false},{\"path\":\"/play/:gameId\",\"regex\":\"^/play/([^/]+)$\",\"paramNames\":[\"gameId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/auth/access-denied\"},{\"path\":\"/auth/sandbox-callback\"},{\"path\":\"/auth/signin/email-link-verify\"},{\"path\":\"/dashboard\"},{\"path\":\"/dashboard/community\"},{\"path\":\"/dashboard/projects\"},{\"path\":\"/dashboard/prompts\"},{\"path\":\"/editor\"},{\"path\":\"/internal/engine-thumbnail-generator\"},{\"path\":\"/play-in-editor\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/sso-callback\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import { applySentryNextjsEditorTags } from '@/lib/sentry/applySentryVersionTags';
import {
  sentryBeforeSendExcludePlayRoutes,
  sentryTransactionMatchesExcludedPlayRoute,
} from '@/lib/sentry/excludePlayRoutesFromSentry';

// Only load Sentry in production to avoid HMR issues in development where
// the appRouterRoutingInstrumentation module can become stale after hot updates.
if (process.env.NODE_ENV === 'production') {
  void import('@sentry/nextjs').then((Sentry) => {
    Sentry.init({
      dsn: 'https://f95075352fdd4f89b0a2160f31e08a36@o17083.ingest.us.sentry.io/4505225795862528',

      beforeSend: sentryBeforeSendExcludePlayRoutes,
      beforeSendTransaction(event) {
        if (sentryTransactionMatchesExcludedPlayRoute(event.transaction)) {
          return null;
        }
        return event;
      },

      // Add optional integrations for additional features
      integrations: [
        // Sentry.replayIntegration(),
        Sentry.consoleLoggingIntegration({levels: ['error', 'warn']}),
      ],

      // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
      tracesSampleRate: 0,
      // Enable logs to be sent to Sentry
      enableLogs: true,

      // Define how likely Replay events are sampled.
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.1,

      // Define how likely Replay events are sampled when an error occurs.
      replaysOnErrorSampleRate: 1.0,

      // Enable sending user PII (Personally Identifiable Information)
      // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
      sendDefaultPii: false,
    });
    applySentryNextjsEditorTags(Sentry);
  });
}

export const onRouterTransitionStart = async (
  ...args: Parameters<typeof import('@sentry/nextjs').captureRouterTransitionStart>
): Promise<void> => {
  if (process.env.NODE_ENV === 'production') {
    const { captureRouterTransitionStart } = await import('@sentry/nextjs');
    captureRouterTransitionStart(...args);
  }
};